var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIc20Photos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C13.6569 5 15 6.34315 15 8V15C15 16.6569 13.6569 18 12 18H5C3.34315 18 2 16.6569 2 15V8C2 6.34315 3.34315 5 5 5H12ZM12 7H5C4.44772 7 4 7.44772 4 8V14.697L6.18627 11.4188C6.50017 10.9793 7.09949 10.8737 7.54124 11.159L7.64018 11.2318L10.7853 15.5193L13 13V8C13 7.44772 12.5523 7 12 7ZM15 2C16.5977 2 17.9037 3.24892 17.9949 4.82373L18 5V12C18 12.5523 17.5523 13 17 13C16.4872 13 16.0645 12.614 16.0067 12.1166L16 12V5C16 4.48716 15.614 4.06449 15.1166 4.00673L15 4H8C7.44772 4 7 3.55228 7 3C7 2.48716 7.38604 2.06449 7.88338 2.00673L8 2H15Z",
    fill: "#296FD8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc20Photos);
export default __webpack_public_path__ + "static/media/ic20-photos.3cb4006b22a895f12425a049b5f72df7.svg";
export { ForwardRef as ReactComponent };